if (!customElements.get("countdown-timer")) {
  class t extends HTMLElement {
    constructor() {
      super(),
        (this.endDate = new Date(this.dataset.endDate).getTime()),
        Number(this.endDate) &&
          window.initLazyScript(this, this.init.bind(this));
    }
    init() {
      (this.daysEl = this.querySelector(".js-days")),
        (this.hoursEl = this.querySelector(".js-hours")),
        (this.minsEl = this.querySelector(".js-mins")),
        (this.secsEl = this.querySelector(".js-secs")),
        (this.second = 1e3),
        (this.minute = 60 * this.second),
        (this.hour = 60 * this.minute),
        (this.day = 24 * this.hour),
        this.timer(),
        (this.interval = setInterval(this.timer.bind(this), this.second));
    }
    timer() {
      const t = this.endDate - new Date();
      if (t < 0) return void clearInterval(this.interval);
      const s = Math.floor(t / this.day),
        e = Math.floor(t / this.hour),
        i = Math.floor(t / this.minute),
        n = Math.floor(t / this.second);
      (this.daysEl.textContent = s),
        (this.hoursEl.textContent = e - 24 * s),
        (this.minsEl.textContent = i - 60 * e),
        (this.secsEl.textContent = n - 60 * i);
    }
  }
  customElements.define("countdown-timer-mk", t);
}

